import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllDullReceipt = createAsyncThunk(
  "DullReceipt/FindAllDullReceipt",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/FindAllDullReceipt`,
        formData
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Dull Receipt", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createDullReceipt = createAsyncThunk(
  "DullReceipt/InsertDullReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/InsertDullReceipt`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Dull Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDullReceipt = createAsyncThunk(
  "DullReceipt/UpdateDullReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/UpdateDullReceipt`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Dull Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDullReceipt = createAsyncThunk(
  "DullReceipt/DeleteDullReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/DeleteDullReceipt`,
        { dull_receipt_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Dull Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDullReceiptById = createAsyncThunk(
  "DullReceipt/FindByIDDullReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/FindByIDDullReceipt`,
        { dull_receipt_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        dull_receipt_guid: result.dull_receipt_guid,
        dull_receipt_no: result.dull_receipt_no,
        receipt_date: result.receipt_date
          ? moment(result.receipt_date).toDate()
          : "",

        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        karigar_nick_name: result.karigar_nick_name,
        charges: result.charges,
        gold_rate: result.gold_rate,
        dull_receipt_order: result?.dull_receipt_order,
        karigarIdWiseOutStandingAmount: result?.karigarIdWiseOutStandingAmount,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Dull Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDullReceiptOrderItems = createAsyncThunk(
  "DullReceipt/DeleteDullReceiptOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/DeleteDullReceiptOrder`,
        { id: ID }
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Dull Receipt Order item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDullReceiptImage = createAsyncThunk(
  "DullReceipt/DullReceiptImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/DullReceiptImageUpdate`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Dull Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findAllPendingDullOrder = createAsyncThunk(
  "DullReceipt/DullPendingOrderList",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/DullReceipt/DullPendingOrderList`,
        formData
      );

      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Dull Receipt", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
